var map = {
	"./Declined.png": "./src/assets/icons/Declined.png",
	"./FILTER.png": "./src/assets/icons/FILTER.png",
	"./Heavyrain.png": "./src/assets/icons/Heavyrain.png",
	"./Horizantal_Nav_Top_Nomal Size_42x42.png": "./src/assets/icons/Horizantal_Nav_Top_Nomal Size_42x42.png",
	"./Horizantal_Nav_Top_onhover Size_62x62.png": "./src/assets/icons/Horizantal_Nav_Top_onhover Size_62x62.png",
	"./Kandla.png": "./src/assets/icons/Kandla.png",
	"./MBPT.png": "./src/assets/icons/MBPT.png",
	"./MSIL-G.png": "./src/assets/icons/MSIL-G.png",
	"./MSIL-M.png": "./src/assets/icons/MSIL-M.png",
	"./MSIL-SIL.png": "./src/assets/icons/MSIL-SIL.png",
	"./MUN.png": "./src/assets/icons/MUN.png",
	"./No warning.png": "./src/assets/icons/No warning.png",
	"./PIPAV.png": "./src/assets/icons/PIPAV.png",
	"./SEARCH.png": "./src/assets/icons/SEARCH.png",
	"./SIDE-NAV.png": "./src/assets/icons/SIDE-NAV.png",
	"./SMG.png": "./src/assets/icons/SMG.png",
	"./TOP-NAV.png": "./src/assets/icons/TOP-NAV.png",
	"./TVP-B.png": "./src/assets/icons/TVP-B.png",
	"./TVP-N.png": "./src/assets/icons/TVP-N.png",
	"./Team-invoice-pic-1.png": "./src/assets/icons/Team-invoice-pic-1.png",
	"./Team-invoice-pic-2.png": "./src/assets/icons/Team-invoice-pic-2.png",
	"./Team-invoice-pic-3.png": "./src/assets/icons/Team-invoice-pic-3.png",
	"./Team-invoice-pic-4.png": "./src/assets/icons/Team-invoice-pic-4.png",
	"./Team-invoice-pic-5.png": "./src/assets/icons/Team-invoice-pic-5.png",
	"./accident alert_16.jpeg": "./src/assets/icons/accident alert_16.jpeg",
	"./accident alert_24.jpeg": "./src/assets/icons/accident alert_24.jpeg",
	"./accident alert_32.jpeg": "./src/assets/icons/accident alert_32.jpeg",
	"./alert.png": "./src/assets/icons/alert.png",
	"./announcement.png": "./src/assets/icons/announcement.png",
	"./arrow_next.png": "./src/assets/icons/arrow_next.png",
	"./bar-chart.png": "./src/assets/icons/bar-chart.png",
	"./barrier.png": "./src/assets/icons/barrier.png",
	"./black-circle.png": "./src/assets/icons/black-circle.png",
	"./blue-dot-2.png": "./src/assets/icons/blue-dot-2.png",
	"./blue-dot.png": "./src/assets/icons/blue-dot.png",
	"./boat.png": "./src/assets/icons/boat.png",
	"./business.png": "./src/assets/icons/business.png",
	"./cf.png": "./src/assets/icons/cf.png",
	"./client-feedback.png": "./src/assets/icons/client-feedback.png",
	"./clock.png": "./src/assets/icons/clock.png",
	"./close.png": "./src/assets/icons/close.png",
	"./cloudy.png": "./src/assets/icons/cloudy.png",
	"./cold_wave.png": "./src/assets/icons/cold_wave.png",
	"./crane.png": "./src/assets/icons/crane.png",
	"./customer_delivered_pin_38.png": "./src/assets/icons/customer_delivered_pin_38.png",
	"./customer_pin.png": "./src/assets/icons/customer_pin.png",
	"./customer_pin_16.png": "./src/assets/icons/customer_pin_16.png",
	"./customer_pin_38.png": "./src/assets/icons/customer_pin_38.png",
	"./cyclone.png": "./src/assets/icons/cyclone.png",
	"./database.png": "./src/assets/icons/database.png",
	"./dedline-projects.png": "./src/assets/icons/dedline-projects.png",
	"./delivery.png": "./src/assets/icons/delivery.png",
	"./delivery_truck.png": "./src/assets/icons/delivery_truck.png",
	"./detour.png": "./src/assets/icons/detour.png",
	"./dot.png": "./src/assets/icons/dot.png",
	"./enmovil.png": "./src/assets/icons/enmovil.png",
	"./files.png": "./src/assets/icons/files.png",
	"./funnel.png": "./src/assets/icons/funnel.png",
	"./gas-station.png": "./src/assets/icons/gas-station.png",
	"./gmarker.png": "./src/assets/icons/gmarker.png",
	"./googletruck.png": "./src/assets/icons/googletruck.png",
	"./green-dot.png": "./src/assets/icons/green-dot.png",
	"./hailstorm.png": "./src/assets/icons/hailstorm.png",
	"./heartbeat.png": "./src/assets/icons/heartbeat.png",
	"./heavywind.png": "./src/assets/icons/heavywind.png",
	"./home.png": "./src/assets/icons/home.png",
	"./icon_data_top_main-2.png": "./src/assets/icons/icon_data_top_main-2.png",
	"./icon_data_top_main-3.png": "./src/assets/icons/icon_data_top_main-3.png",
	"./icon_data_top_main-3.psd": "./src/assets/icons/icon_data_top_main-3.psd",
	"./icon_data_top_main-4.png": "./src/assets/icons/icon_data_top_main-4.png",
	"./icon_data_top_main.png": "./src/assets/icons/icon_data_top_main.png",
	"./invoice-data.png": "./src/assets/icons/invoice-data.png",
	"./kpi.png": "./src/assets/icons/kpi.png",
	"./loader.gif": "./src/assets/icons/loader.gif",
	"./loadingyard.png": "./src/assets/icons/loadingyard.png",
	"./logo.jpeg": "./src/assets/icons/logo.jpeg",
	"./logo.png": "./src/assets/icons/logo.png",
	"./marketing-strategy.png": "./src/assets/icons/marketing-strategy.png",
	"./maruti-logo-login.png": "./src/assets/icons/maruti-logo-login.png",
	"./maruti-logo.png": "./src/assets/icons/maruti-logo.png",
	"./mausam - cold day.png": "./src/assets/icons/mausam - cold day.png",
	"./mausam - cold wave.png": "./src/assets/icons/mausam - cold wave.png",
	"./mausam - dust raising winds.png": "./src/assets/icons/mausam - dust raising winds.png",
	"./mausam - dust storm.png": "./src/assets/icons/mausam - dust storm.png",
	"./mausam - fog.png": "./src/assets/icons/mausam - fog.png",
	"./mausam - ground froast.png": "./src/assets/icons/mausam - ground froast.png",
	"./mausam - hailstorm.png": "./src/assets/icons/mausam - hailstorm.png",
	"./mausam - heat wave.png": "./src/assets/icons/mausam - heat wave.png",
	"./mausam - heavy rain.png": "./src/assets/icons/mausam - heavy rain.png",
	"./mausam - heavy snow.png": "./src/assets/icons/mausam - heavy snow.png",
	"./mausam - hot day.png": "./src/assets/icons/mausam - hot day.png",
	"./mausam - strong surface winds.png": "./src/assets/icons/mausam - strong surface winds.png",
	"./mausam - thunderstorm.png": "./src/assets/icons/mausam - thunderstorm.png",
	"./mausam - warm night.png": "./src/assets/icons/mausam - warm night.png",
	"./media.png": "./src/assets/icons/media.png",
	"./new-logo.png": "./src/assets/icons/new-logo.png",
	"./paid.png": "./src/assets/icons/paid.png",
	"./pending.png": "./src/assets/icons/pending.png",
	"./performance.png": "./src/assets/icons/performance.png",
	"./plant_w.png": "./src/assets/icons/plant_w.png",
	"./red-dot.png": "./src/assets/icons/red-dot.png",
	"./sandstorm.png": "./src/assets/icons/sandstorm.png",
	"./settings.png": "./src/assets/icons/settings.png",
	"./ship.png": "./src/assets/icons/ship.png",
	"./sidenav-blue.png": "./src/assets/icons/sidenav-blue.png",
	"./snowflake.png": "./src/assets/icons/snowflake.png",
	"./snowy.png": "./src/assets/icons/snowy.png",
	"./start_port.png": "./src/assets/icons/start_port.png",
	"./stats.png": "./src/assets/icons/stats.png",
	"./stop_marker.png": "./src/assets/icons/stop_marker.png",
	"./team-award.png": "./src/assets/icons/team-award.png",
	"./thunderstorm.png": "./src/assets/icons/thunderstorm.png",
	"./tolls-image.png": "./src/assets/icons/tolls-image.png",
	"./topnav-blue.png": "./src/assets/icons/topnav-blue.png",
	"./track_start.png": "./src/assets/icons/track_start.png",
	"./train-msil.png": "./src/assets/icons/train-msil.png",
	"./train.png": "./src/assets/icons/train.png",
	"./traindeliver.png": "./src/assets/icons/traindeliver.png",
	"./transportation.png": "./src/assets/icons/transportation.png",
	"./trending.png": "./src/assets/icons/trending.png",
	"./truck-end.png": "./src/assets/icons/truck-end.png",
	"./truck.png": "./src/assets/icons/truck.png",
	"./truck_1_24.png": "./src/assets/icons/truck_1_24.png",
	"./truck_1_32.png": "./src/assets/icons/truck_1_32.png",
	"./truck_2_24.png": "./src/assets/icons/truck_2_24.png",
	"./truck_2_32.png": "./src/assets/icons/truck_2_32.png",
	"./truck_3_24.png": "./src/assets/icons/truck_3_24.png",
	"./truck_3_32.png": "./src/assets/icons/truck_3_32.png",
	"./truck_4_24.png": "./src/assets/icons/truck_4_24.png",
	"./truck_4_32.png": "./src/assets/icons/truck_4_32.png",
	"./truck_5_24.png": "./src/assets/icons/truck_5_24.png",
	"./truck_5_32.png": "./src/assets/icons/truck_5_32.png",
	"./truck_6_24.png": "./src/assets/icons/truck_6_24.png",
	"./truck_6_32.png": "./src/assets/icons/truck_6_32.png",
	"./truck_7_24.png": "./src/assets/icons/truck_7_24.png",
	"./truck_7_32.png": "./src/assets/icons/truck_7_32.png",
	"./truck_atdealer_24.png": "./src/assets/icons/truck_atdealer_24.png",
	"./truck_atdealer_32.png": "./src/assets/icons/truck_atdealer_32.png",
	"./truck_atdelar.png": "./src/assets/icons/truck_atdelar.png",
	"./truck_dealer.png": "./src/assets/icons/truck_dealer.png",
	"./truck_empty_24.png": "./src/assets/icons/truck_empty_24.png",
	"./truck_empty_32.png": "./src/assets/icons/truck_empty_32.png",
	"./truck_emptyatplant.png": "./src/assets/icons/truck_emptyatplant.png",
	"./truck_going_24.png": "./src/assets/icons/truck_going_24.png",
	"./truck_going_32.png": "./src/assets/icons/truck_going_32.png",
	"./truck_inside.png": "./src/assets/icons/truck_inside.png",
	"./truck_inside_24.png": "./src/assets/icons/truck_inside_24.png",
	"./truck_inside_32.png": "./src/assets/icons/truck_inside_32.png",
	"./truck_leftdealer_24.png": "./src/assets/icons/truck_leftdealer_24.png",
	"./truck_leftdealer_32.png": "./src/assets/icons/truck_leftdealer_32.png",
	"./truck_na_24.png": "./src/assets/icons/truck_na_24.png",
	"./truck_na_32.png": "./src/assets/icons/truck_na_32.png",
	"./truck_null.png": "./src/assets/icons/truck_null.png",
	"./truck_outside_.png": "./src/assets/icons/truck_outside_.png",
	"./truck_overspeed.png": "./src/assets/icons/truck_overspeed.png",
	"./truck_return_24.png": "./src/assets/icons/truck_return_24.png",
	"./truck_return_32.png": "./src/assets/icons/truck_return_32.png",
	"./truck_returnplant.png": "./src/assets/icons/truck_returnplant.png",
	"./truckblue.png": "./src/assets/icons/truckblue.png",
	"./truckgreen.png": "./src/assets/icons/truckgreen.png",
	"./truckmsil.png": "./src/assets/icons/truckmsil.png",
	"./truckred.png": "./src/assets/icons/truckred.png",
	"./unloadingyard.png": "./src/assets/icons/unloadingyard.png",
	"./user-map.png": "./src/assets/icons/user-map.png",
	"./voltagewarning_16.jpeg": "./src/assets/icons/voltagewarning_16.jpeg",
	"./voltagewarning_24.jpeg": "./src/assets/icons/voltagewarning_24.jpeg",
	"./warning.png": "./src/assets/icons/warning.png",
	"./watch.png": "./src/assets/icons/watch.png",
	"./weather.png": "./src/assets/icons/weather.png",
	"./wind.png": "./src/assets/icons/wind.png",
	"./yellow-dot.png": "./src/assets/icons/yellow-dot.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";